module.exports = __webpack_public_path__ + "static/img/1_1_6.fc378632.jpg";